import { MEASUREMENT_TYPES } from "../../../../../config/enums/MeasurementTypes";
import { TransportTypeOption } from "./externalTransport.types";

export const mergeRetiredTransportType = (
  options: TransportTypeOption[],
  savedTypeId: string | number | undefined
): TransportTypeOption[] => {
  if (savedTypeId === undefined || savedTypeId === null || savedTypeId === "") {
    return options;
  }
  const savedKey = String(savedTypeId);
  if (options.some(option => String(option.value) === savedKey)) {
    return options;
  }
  return [
    ...options,
    {
      key: savedKey,
      value: savedKey,
      text: `Type ${savedKey}`
    }
  ];
};

export const mapTransportationTypesToOptions = (items: any[] = []): TransportTypeOption[] =>
  items.map(item => ({
    key: item.id,
    value: item.id,
    text: item.transportation_name
  }));

/** Display-only t·km: weight (kg or ton) × distance (km). Does not alter persisted values. */
export const calculateFreightWorkTkm = (
  weight: number | string | undefined,
  weightUnit: number | undefined,
  distance: number | string | undefined
): number | null => {
  const numericWeight = Number(weight);
  const numericDistance = Number(distance);
  if (!Number.isFinite(numericWeight) || !Number.isFinite(numericDistance)) {
    return null;
  }
  if (numericWeight <= 0 || numericDistance <= 0) {
    return null;
  }
  const weightInTons =
    weightUnit === MEASUREMENT_TYPES.WEIGHT_TON ? numericWeight : numericWeight / 1000;
  return weightInTons * numericDistance;
};

export const formatFreightWorkTkm = (
  weight: number | string | undefined,
  weightUnit: number | undefined,
  distance: number | string | undefined,
  apiValue?: number | string | null
): string => {
  if (apiValue !== undefined && apiValue !== null && apiValue !== "") {
    const parsed = Number(apiValue);
    if (Number.isFinite(parsed)) {
      return parsed.toFixed(2);
    }
  }
  const calculated = calculateFreightWorkTkm(weight, weightUnit, distance);
  return calculated === null ? "—" : calculated.toFixed(2);
};

export const formatRouteLabel = (from?: string, to?: string): string => {
  const fromLabel = from?.trim() || "—";
  const toLabel = to?.trim() || "—";
  return `${fromLabel} → ${toLabel}`;
};
